let clusterData = {}
export default clusterData;


// WEBPACK FOOTER //
// ./src/scripts/data/cluster-data.js